module.exports = __webpack_public_path__ + "img/REVOLUTION__1_-removebg-preview-p-1080.1250498d.png";